import type { SearchDataType } from '../service/types';

export const SEARCH_DEFAULT_VALUES: SearchDataType = {
    profileId: '',
    search_country: '91',
    mobile_number: '',
    mother_tongue: '',
    age: [18, 65],
    caste: '',
    height: undefined,
    weight: [30, 200],
    wellness_eating_habits: '',
    marital_status: '',
    profession_annual_income: '',
    profession_qualification: '',
    profession_jobTitle: "",
    profession_country: '',
    profession_region: '',
    profession_district: '',
    profession_panchayath: '',
    family_status: '',
    family_net_worth: '',
    horoscope_preference: '',
    horoscope_star: '',
    horoscope_raasi: '',
    horoscope_dosham: '',
    address_country: '',
    address_region: '',
    address_district: '',
    address_panchayath: '',

    address_country_id: undefined as unknown as number,
    address_region_id: undefined as unknown as number,
    address_district_id: undefined as unknown as number,
    address_panchayath_id: undefined as unknown as number,
    profession_country_id: undefined as unknown as number,
    profession_region_id: undefined as unknown as number,
    profession_district_id: undefined as unknown as number,
    profession_panchayath_id: undefined as unknown as number,
};
